import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'pics-sandbox';

  ngAfterViewInit() {
    const tooltipEl = document.createElement('div');
    tooltipEl.className = 'p-tooltip p-component p-tooltip-top pcustom-tooltip';
    tooltipEl.style.cssText = 'position:fixed; z-index:9999; display:none; pointer-events:none;';
    tooltipEl.innerHTML = '<div class="p-tooltip-arrow"></div><div class="p-tooltip-text"></div>';
    document.body.appendChild(tooltipEl);

    const tooltipText = tooltipEl.querySelector('.p-tooltip-text') as HTMLElement;
    const tooltipArrow = tooltipEl.querySelector('.p-tooltip-arrow') as HTMLElement;

    const showTooltip = (el: HTMLElement) => {
      const text = el.getAttribute('data-tooltip-text');
      if (!text) return;

      tooltipText.innerText = text;
      tooltipEl.style.display = 'block';

      const rect = el.getBoundingClientRect();
      const tooltipRect = tooltipEl.getBoundingClientRect();

      const top = rect.top - tooltipRect.height - 8;
      const left = rect.left + rect.width / 2 - tooltipRect.width / 2;

      tooltipEl.style.top = `${top}px`;
      tooltipEl.style.left = `${left}px`;
    };

    const hideTooltip = () => {
      tooltipEl.style.display = 'none';
    };

    const observer = new MutationObserver(() => {
      document.querySelectorAll('.choices__list--single .choices__item').forEach((el: HTMLElement) => {
        if (!el.getAttribute('ptooltip-applied')) {
          const text = el.innerText?.trim();
          if (text) {
            el.setAttribute('data-tooltip-text', text);
            el.setAttribute('ptooltip-applied', 'true');

            el.addEventListener('mouseenter', () => showTooltip(el));
            el.addEventListener('mouseleave', hideTooltip);
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}
